'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var standardDialog = require('../standard-dialog/standard-dialog.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledIFrameDialog = (props)=>{
    const { className , iframeProps , src , title , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(standardDialog.StandardDialog, _extends({}, otherProps, {
        /**
       * `autoFocus` attribute has no effect since it's not possible to autofocus inside an
       * `<iframe>` to its `<input>`, `<textarea>`, `<button>`, etc.
       */ autoFocus: false,
        className: classnames__default.default({
            'iframe-dialog': true,
            [`${className}`]: !!className
        }),
        contentCentered: false,
        focusLock: false,
        loading: false,
        showFooter: false,
        title: title
    }), /*#__PURE__*/ React__default.default.createElement("iframe", _extends({}, iframeProps, {
        className: classnames__default.default({
            'iframe-dialog__iframe': true,
            [`${iframeProps?.className}`]: !!iframeProps?.className
        }),
        src: src,
        title: title
    })));
};
const StyledIFrameDialog = styled__default.default(UnstyledIFrameDialog)`
  .bf-dialog__body {
    display: flex;
    flex: 1;
    padding: 0;
  }

  .bf-dialog__autofocus {
    display: flex;
    flex: 1;
  }

  .iframe-dialog__iframe {
    border: 0;
    flex: 1;
    min-height: 280px;
    width: 100%;
  }
`;
/**
 * A convenience component that uses `<StandardDialog>` to display an `<iframe>` inside the dialog.
 *
 * The `title` attribute is required for proper accessibility for the `<iframe>` `title` attribute
 * and for the dialog itself. `id`, `labels`, `open`, and `setOpen` are also required.
 *
 * For Smartsheet `<iframe>` forms, set `width` to `610`.
 */ const IFrameDialog = (props)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledIFrameDialog, _extends({}, props)));
};

exports.IFrameDialog = IFrameDialog;
//# sourceMappingURL=iframe-dialog.js.map
